import { InvoiceInput, InvoiceResponse, RunSaveAndSendInvoiceInput } from '@/models/gen/graphql';

import { GraphApiResponse } from '@/api/core';
import { RunSaveAndSendInvoiceDocument } from '@/api/queries';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';
import { handleError } from '@/utils';

type RunSaveAndSendInvoiceGraphApiResponse = GraphApiResponse<typeof RunSaveAndSendInvoiceDocument>;

const title = 'Save And Send Invoice';

const runSaveAndSendInvoiceResponseSelector = (res: RunSaveAndSendInvoiceGraphApiResponse): InvoiceResponse =>
  !res.errors ? (res?.runSaveAndSendInvoice?.output as InvoiceResponse) : undefined;

const [runRunSaveAndSendInvoice] = graphApi(RunSaveAndSendInvoiceDocument, {
  onError: (res: RunSaveAndSendInvoiceGraphApiResponse): void => handleError(res, { notification: { title } }),
});

export const runSaveAndSendInvoice = async (invoice: InvoiceInput): Promise<InvoiceResponse> => {
  const input: RunSaveAndSendInvoiceInput = { input: invoice };
  const res = await runRunSaveAndSendInvoice({ input });

  const selected = runSaveAndSendInvoiceResponseSelector(res);

  return selected;
};

export const useRunSaveAndSendInvoice = createGraphApiHook(runSaveAndSendInvoice);

export default runSaveAndSendInvoice;
